import { BusinessPreview as BusinessPreviewComponent } from './BusinessPreview';

export const BusinessPreview = BusinessPreviewComponent;
